import React from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import LinkWrap from '../link_wrap';

import './rich-text.scss';

const RichText = (props) => {
  const classes = ['rich-text'];
  classes.push('theme-' + props.blok.theme);

  if (props.blok.text_alignment) {
    classes.push('text-alignment-' + props.blok.text_alignment);
  }

  const strongColor =
    props.blok.strong_color &&
    props.blok.strong_color.color &&
    props.blok.strong_color.color !== '#f40000'
      ? props.blok.strong_color
      : '';

  return (
    <div className={classes.join(' ')}>
      <SbEditable content={props.blok}>
        <div>
          <MarkdownStyled
            children={props.blok.body}
            textSize={props.blok.text_size || 0.9}
            lineHeightRatio={props.blok.line_height_ratio || 2}
            strongColor={strongColor || 'inherit'}
            components={{
              a: ({ node, ...props }) => {
                return <LinkWrap to={props.href} {...props} />;
              },
            }}
          />
        </div>
      </SbEditable>
    </div>
  );
};

const MarkdownStyled = styled((props) => <ReactMarkdown {...props} />)`
  font-size: ${(props) => props.textSize}rem;
  line-height: ${(props) => props.textSize * props.lineHeightRatio}rem;

  strong {
    color: ${(props) => props.strongColor};
  }
`;

export default RichText;
